import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * Our type scale, as tailwind-merge needs to know it.
 *
 * These are `fontSize` keys in `tailwind.config.js`, so `text-heading-2` is a
 * SIZE. tailwind-merge only knows Tailwind's stock size names (`text-sm`,
 * `text-2xl`, …), so without this it filed every custom one under *colour* and
 * "resolved the conflict" between `text-heading-2` and `text-secondary` by
 * throwing the size away.
 *
 * That is not theoretical: `cn('text-heading-2 text-secondary', …)` is how the
 * team KPI strip was written, and every figure on /team rendered at 16px/400
 * instead of 24px/900 — a whole hero row silently a third of its intended size.
 * Anything merged through `cn` was one class-order away from the same bug.
 *
 * Keep this list in step with `tailwind.config.js#theme.extend.fontSize`.
 */
const FONT_SIZES = [
  'display-1',
  'display-2',
  'heading-1',
  'heading-2',
  'heading-3',
  'heading-4',
  'body-lg',
  'body',
  'body-sm',
  'caption',
];

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{ text: FONT_SIZES }],
    },
  },
});

/** Merge class names, resolving Tailwind conflicts (shadcn convention). */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
